import React from 'react';
import { Nav } from 'react-bootstrap';
import '../style/sidebar.css'; // Estilos customizados
import menuLogo from "../assets/imagens/pentalobe.png";
import {useLocation } from 'react-router-dom'; // Importe Link e useLocation para roteamento
const Sidebar = ({ isOpen }) => {

  const location = useLocation(); // Hook para acessar a localização atual

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      {/* Logo */}
      <div className="sidebar-header">
        <img className="fundo-imagem-dasboard" src={menuLogo} alt="fundo-imagem-dasboard" />
      </div>

      {/* Menu de navegação */}
      <Nav defaultActiveKey="/Dasboard" className="flex-column">
        <Nav.Link href="/index" active={location.pathname === '/index'}>
        <i class="fa-solid fa-chart-pie"></i> Dashboard
        </Nav.Link>
        <Nav.Link href="/propostas" active={location.pathname === '/propostas'}>
          <i class="fa-solid fa-business-time"></i> Pedido de Compras
        </Nav.Link>
        <Nav.Link href="/vendas" active={location.pathname === '/vendas'}>
          <i class="fa-solid fa-cart-shopping"></i> Pedido de Vendas
        </Nav.Link>
        <Nav.Link href="/cadastros" active={location.pathname === '/cadastros'}>
          <i class="fa-solid fa-address-card"></i> Produtos
        </Nav.Link>
        <Nav.Link href="/avaliacoes" active={location.pathname === '/avaliacoes'}>
          <i className="fas fa-chart-line"></i> Avaliador
        </Nav.Link>
        <Nav.Link href="/blog-painel" active={location.pathname === '/blog-painel'}>
          <i class="fa-solid fa-blog"></i> Blog
        </Nav.Link>
        <Nav.Link href="/usuarios" active={location.pathname === '/usuarios'}>
          <i className="fa-solid fa-user-tie"></i> Usuários
        </Nav.Link>
        <Nav.Link href="/configuracoes" active={location.pathname === '/configuracoes'}>
          <i className="fas fa-cogs"></i>Configurações
        </Nav.Link>
      </Nav>
    </div >
  );
};

export default Sidebar;
